import React from 'react';
import CategorizedArticles from './CategorizedArticles';
import CustomerServiceHelp from './CustomerServiceHelp';
import FaqArticles from './FaqArticles';
import { ICustomerService } from './ICustomerService';
import { ICustomerServiceApi } from './ICustomerServiceApi';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';

export interface CustomerServiceMainProps {
    data: ICustomerService;
    api: ICustomerServiceApi;
}

const CustomerServiceMain = ({ data, api }: CustomerServiceMainProps) => {
    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    return (
        <>
            <h3 className="customer-service-faq__top-questions">{t('topCustomerQuestions')}</h3>
            <FaqArticles articles={data.FaqArticles} api={api} />
            <CategorizedArticles articles={data.CategorizedArticles} />
            <CustomerServiceHelp />
        </>
    );
};

export default CustomerServiceMain;
